module.exports = __webpack_public_path__ + "static/media/soumya-rajan.8725707a.jpeg";